module.exports = __webpack_public_path__ + "static/nat-3-7974f842ae15f6e6c668ea82e4657f75.jpg";